__turbopack_context__.v({
  "fadeInItems": "archive-module__38YClW__fadeInItems",
  "post": "archive-module__38YClW__post",
  "posts": "archive-module__38YClW__posts",
  "spacing--lg": "archive-module__38YClW__spacing--lg",
  "spacing--md": "archive-module__38YClW__spacing--md",
  "spacing--sm": "archive-module__38YClW__spacing--sm",
  "spacing--xl": "archive-module__38YClW__spacing--xl",
  "spacing--xs": "archive-module__38YClW__spacing--xs",
  "spacing--xxl": "archive-module__38YClW__spacing--xxl",
  "spacing--xxs": "archive-module__38YClW__spacing--xxs",
  "spacing--xxxl": "archive-module__38YClW__spacing--xxxl",
  "spacing--xxxs": "archive-module__38YClW__spacing--xxxs",
});
